import { SCREEN_BREAKPOINTS } from 'js/constants/breakpoints';

const Platform = {
  isMobile: () => {
    return $(window).width() <= SCREEN_BREAKPOINTS.MOBILE_MAX_WIDTH;
  },

  isTablet: () => {
    const $width = $(window).width();

    return $width <= SCREEN_BREAKPOINTS.TABLET_MAX_WIDTH && $width >= SCREEN_BREAKPOINTS.TABLET_MIN_WIDTH;
  },

  isDesktop: () => {
    return $(window).width() >= SCREEN_BREAKPOINTS.DESKTOP_MIN_WIDTH;
  },

  isIos: () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  },
};

export default Platform;
